module.exports = __webpack_public_path__ + "img/pos1.57d697c3.jpg";